import React from "react";
import Identicon from "identicon.js"
import "./navbar.css";

const Navbar = ({ user }) => {
	let data;
	if (user) {
		data = new Identicon(user, 420).toString();
	}
	return(
		<div className="navbar">
			<div>Decentralized Exchange Tdog USDG</div>
			<div>{ user }</div>
			<div><img width="6" height="6" alt="" src={`data:image/png;base64,${data}`}/></div>
		</div>
	)
}

export default Navbar;